import { CloudOff, RefreshCw } from "lucide-react";

export const GuestRetryScreen = ({ onRetry }) => (
  <div className="min-h-screen bg-background flex flex-col items-center justify-center px-6 text-center" data-testid="guest-retry-screen">
    <CloudOff className="w-10 h-10 text-muted-foreground mb-4" />
    <h1 className="font-heading font-extrabold text-2xl mb-3">Server even niet bereikbaar</h1>
    <p className="text-muted-foreground mb-2 max-w-md">
      De reis kan momenteel niet geladen worden — waarschijnlijk een korte onderbreking (bv. een update van de app).
    </p>
    <p className="text-sm text-muted-foreground mb-6 flex items-center gap-2 justify-center">
      <span className="w-3.5 h-3.5 rounded-full border-2 border-primary border-t-transparent animate-spin inline-block" />
      We proberen het automatisch opnieuw…
    </p>
    <button data-testid="guest-retry-button" onClick={onRetry}
      className="rounded-full bg-primary hover:bg-[#1B4332] text-primary-foreground px-6 py-3 text-sm font-semibold flex items-center gap-2 transition-[background-color] duration-200">
      <RefreshCw className="w-4 h-4" /> Probeer nu opnieuw
    </button>
  </div>
);
